import { booleanAttribute, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DocumentViewModel } from '../model/document-view-model';

@Component({
    selector: 'app-document-item',
    templateUrl: './document-item.component.html',
    styleUrls: ['./document-item.component.scss'],
    standalone: false
})
export class DocumentItemComponent implements OnInit {

  @Input() viewModel: DocumentViewModel;

  @Input({ transform: booleanAttribute }) allowAdd: boolean;

  @Output() delete = new EventEmitter<DocumentViewModel>();

  constructor() { }

  ngOnInit(): void {
  }

  deleteDocument(viewModel: DocumentViewModel) {
    this.delete.next(viewModel);
  }

}
